import React, { useState, useContext, useEffect, useRef } from "react";
// import Cookies from "js-cookie";
import {
  Button,
  Typography,
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@mui/material";

import ReactQuill from "react-quill";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { errorDialogOpen } from "../../redux/dialogs/dialogActions";
import { ErrorOutline, Save, Clear, Add } from "@mui/icons-material";
import { AddApplicationContext } from "../../context/AddApplicationContext";
import TestComponent from "../../components/TestComponent";
import ErrorModal from "../../components/ErrorModal";
import ErrorText from "../../components/ErrorText";
import { basePath } from "../../utility";
import ProcessProgress from "../../components/ProcessProgress";
import LoaderModal from "../../components/LoaderModal";
import useFetch from "../../hooks/useFetch";
import { fontSize } from "@mui/system";

export default function Education() {
  const [country, setCountry] = useState("");
  // const [openCategories, setOpenCategories] = useState(false);
  // const [contributorType, setContributorType] = useState("author");
  // const [contributorFirstName, setContributorFirstName] = useState("");
  // const [contributorLastName, setContributorLastName] = useState("");
  // const [publisherName, setPublisherName] = useState("");

  // const [nationalityList, setNationalityList] = useState(null);
  // const [ethnicityList, setEthnicityList] = useState(null);
  // const [religionList, setReligionList] = useState(null);
  // const [programList, setProgramList] = useState(null);
  const [programsPerLevel, setProgramsPerLevel] = useState(null);
  const [programLevel, setProgramLevel] = useState(null);
  // const [periodList, setPeriodList] = useState(null);

  const [viewHighSchoolInput, setViewHighSchoolInput] = useState(false);
  const [viewPostHighSchoolInput, setViewPostHighSchoolInput] = useState(true);
  const [resultSlipFile, setResultSlipFile] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [feedback, setFeedback] = useState(null);

  const [openLoader, setOpenLoader] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState(null);
  const [onSuccessButtonLable, setOnSuccessButtonLable] = useState(null);

  const [onErrorButtonLable, setOnErrorButtonLable] = useState(null);
  const url = basePath.url;

  const logger = useSelector((state) => {
    return state.logger;
  });

  const {
    currentStep,
    setStep,
    applicationId,
    setApplicationId,
    stepDetails,
    setStepDetails,
    stepsCompleteStatus,
    setStepsCompletedStatus,
  } = useContext(AddApplicationContext);

  // useEffect(() => {
  //   console.log(stepDetails);
  // });

  useEffect(() => {
    if (
      stepDetails.educationDetails.highSchool &&
      stepDetails.educationDetails.highSchool.length > 0
    ) {
      setViewHighSchoolInput(false);
    } else {
      setViewHighSchoolInput(true);
    }

    if (
      stepDetails.educationDetails.PostHighSchool &&
      stepDetails.educationDetails.PostHighSchool.length > 0
    ) {
      setViewPostHighSchoolInput(false);
    } else {
      setViewPostHighSchoolInput(true);
    }
  }, []);

  const initialValuesHighSchool = {
    highSchoolSystem: "",
    certificateDescription: "",
    indexNumber: "",
    institutionName: "",
    startDate: "",
    endDate: "",
    graduationDate: "",
    meanGrade: "",
    resultSlip: "",
    leavingCertificate: "",
  };

  const initialValuesPostHighSchool = {
    category: "",
    qualificationDescription: "",

    institutionName: "",
    startDate: "",
    endDate: "",
    graduationDate: "",
    meanGrade: "",
    certificate: "",
    transcript: "",
  };

  const validationSchemaPostHighSchool = Yup.object({
    category: Yup.string().required("Please select Qualification Description"),
    qualificationDescription: Yup.string().required(
      "Please select Certificate Description"
    ),

    institutionName: Yup.string().required("Please enter Institution Name"),

    startDate: Yup.date().required("Please select the Start Date"),
    endDate: Yup.date().required("Please select end Date"),
    graduationDate: Yup.date().required("Please enter date of Graduation"),
    meanGrade: Yup.string().required("Please enter Mean Grade Awarded"),

    certificate: Yup.string().required("Please select certificate to upload "),

    transcript: Yup.string().required("Please select transcript to upload"),
  });
  const validationSchemaHighSchool = Yup.object({
    highSchoolSystem: Yup.string().required("Please select highSchoolSystem"),
    certificateDescription: Yup.string().required(
      "Please select Certificate Description"
    ),
    indexNumber: Yup.string().required(
      "Please enter Index/Exam Registration Number"
    ),
    institutionName: Yup.string().required("Please enter Institution Name"),

    startDate: Yup.date().required("Please select the Start Date"),
    endDate: Yup.date().required("Please select end Date"),
    graduationDate: Yup.date().required("Please enter date of Graduation"),
    meanGrade: Yup.string().required("Please enter Mean Grade Awarded"),

    resultSlip: Yup.string().required("Please select result slip to upload "),

    leavingCertificate: Yup.string().required(
      "Please select leaving certificate to upload"
    ),
  });

  const onSuccessCallback = () => {
    setOpenLoader(false);
  };

  const handleNextStep = () => {
    setStep((val) => {
      return val + 1;
    });
  };

  const onErrorCallback = () => {
    setOpenLoader(false);
  };

  const onSubmitDetailsHighSchool = async (values, onSubmitProps) => {
    // console.log(values);

    const user_id = logger.user.userId;

    setError(null);
    setLoading(true);
    setFeedback(null);
    setOpenLoader(true);
    setLoaderMessage("Adding High School Qualification details");
    values.target = "applications";
    values.type = "add";
    values.applicationId = stepDetails.programDetails?.applicationId;

    if (!values.applicationId) {
      alert("Error Fetching Application");
      setError("Error Fetching Application");
      setLoading(false);
      setFeedback(null);

      return;
    }

    const formData = new FormData();

    formData.append("highSchoolSystem", values.highSchoolSystem);

    formData.append("certificateDescription", values.certificateDescription);
    formData.append("indexNumber", values.indexNumber);
    formData.append("target", values.target);
    formData.append("type", values.type);
    formData.append("applicationId", values.applicationId);
    formData.append("institutionName", values.institutionName);
    formData.append("user_id", user_id);
    formData.append("startDate", values.startDate);
    formData.append("endDate", values.endDate);
    formData.append("graduationDate", values.graduationDate);
    formData.append("meanGrade", values.meanGrade);
    formData.append("resultSlip", values.resultSlip);
    formData.append("leavingCertificate", values.leavingCertificate);

    // console.log(formData);

    try {
      const addProgram = await axios.post(
        `${url}application/add-education-highschool`,
        formData
      );
      // console.log(addProgram);
      if (addProgram.data.message === "error") {
        let err_data = addProgram.data.data;
        setError(
          // err_data === "duplicate"
          //   ? "Book with the same  number  exists"
          //   : addProgram.data.data
          "Error Adding High School Details"
        );
        setLoading(false);
        setFeedback(null);
        onSubmitProps.setSubmitting(false);
        // onSubmitProps.resetForm();
      } else {
        if (!addProgram.data.data) {
          setError(true);
          setOnErrorButtonLable("Ok");
          values.type === "add"
            ? setLoaderMessage(
                "Error Adding High School Details! Please try again"
              )
            : setLoaderMessage(
                "Error Updating High School Details! Please try again"
              );
          setLoading(false);
        } else {
          values.id = addProgram.data;

          let step_details = { ...stepDetails };
          if (!step_details.educationDetails.highSchool) {
            step_details.educationDetails.highSchool = [];
          }

          //add highschool database insertId value returned from api call

          step_details.educationDetails.highSchool.push(values);
          setStepDetails(step_details);
          onSubmitProps.setSubmitting(false);
          setViewHighSchoolInput(false);
          onSubmitProps.resetForm();

          setError(null);
          setLoading(false);
          setFeedback("High School Details Added Successfully");
          // onSubmitProps.setSubmitting(false);
          // onSubmitProps.resetForm();
          setOnSuccessButtonLable("Ok");
          // setStep1Completed(true);
          values.type === "add"
            ? setLoaderMessage("High School Details added successfully")
            : setLoaderMessage("High School Details updated successfully");
          setLoading(false);
          setError(null);
        }
      }
    } catch (err) {
      setLoaderMessage(`Error Adding High School Qualification Details `);
      setError("Error Adding High School Qualification Details");
      setOnErrorButtonLable("Ok");
      setLoaderMessage(
        "Error Adding High School Qualification Details! Please try again"
      );

      setLoading(false);
      setFeedback(null);
      onSubmitProps.setSubmitting(false);
    }
  };

  const onSubmitDetailsPostHighSchool = async (values, onSubmitProps) => {
    const user_id = logger.user.userId;

    setError(null);
    setLoading(true);
    setFeedback(null);
    setOpenLoader(true);
    setLoaderMessage("Adding Post High School Qualification details");
    values.target = "applications";
    values.type = "add";
    values.applicationId = stepDetails.programDetails?.applicationId;

    const formData = new FormData();

    formData.append("target", values.target);
    formData.append("type", values.type);
    formData.append("applicationId", values.applicationId);
    formData.append("category", values.category);

    formData.append(
      "qualificationDescription",
      values.qualificationDescription
    );
    formData.append("institutionName", values.institutionName);
    formData.append("user_id", user_id);
    formData.append("startDate", values.startDate);
    formData.append("endDate", values.endDate);
    formData.append("graduationDate", values.graduationDate);
    formData.append("meanGrade", values.meanGrade);

    formData.append("transcript", values.transcript);
    formData.append("certificate", values.certificate);

    console.log(formData);
    try {
      const addProgram = await axios.post(
        `${url}application/add-education-post-highschool`,
        formData
      );
      // console.log(addProgram);
      if (addProgram.data.message === "error") {
        let err_data = addProgram.data.data;
        setError(
          // err_data === "duplicate"
          //   ? "Book with the same  number  exists"
          //   : addProgram.data.data
          "Error Adding Post High School Details"
        );
        setLoading(false);
        setFeedback(null);
        onSubmitProps.setSubmitting(false);
        // onSubmitProps.resetForm();
      } else {
        if (!addProgram.data.data) {
          setError(true);
          setOnErrorButtonLable("Ok");
          values.type === "add"
            ? setLoaderMessage(
                "Error Adding Post High School Details! Please try again"
              )
            : setLoaderMessage(
                "Error Updating Post High School Details! Please try again"
              );
          setLoading(false);
        } else {
          values.id = addProgram.data;

          let step_details = { ...stepDetails };
          if (!step_details.educationDetails.postHighSchool) {
            step_details.educationDetails.postHighSchool = [];
          }

          //add highschool database insertId value returned from api call

          step_details.educationDetails.postHighSchool.push(values);
          setStepDetails(step_details);
          onSubmitProps.setSubmitting(false);
          setViewPostHighSchoolInput(false);
          onSubmitProps.resetForm();

          setError(null);
          setLoading(false);
          setFeedback("Post High School Details Added Successfully");
          // onSubmitProps.setSubmitting(false);
          // onSubmitProps.resetForm();
          setOnSuccessButtonLable("Ok");
          // setStep1Completed(true);
          values.type === "add"
            ? setLoaderMessage("Post High School Details added successfully")
            : setLoaderMessage("Post High School Details updated successfully");
          setLoading(false);
          setError(null);
        }
      }
    } catch (err) {
      setLoaderMessage(`Error Adding Post High School Qualification Details `);
      setError("Error Adding Post High School Qualification Details");
      setOnErrorButtonLable("Ok");
      setLoaderMessage(
        "Error Adding Post High School Qualification Details! Please try again"
      );

      setLoading(false);
      setFeedback(null);
      onSubmitProps.setSubmitting(false);
    }
  };

  async function hadleHighSchoolDelete(id, item_index) {
    const step_details = stepDetails;
    step_details.educationDetails.highSchool.splice(item_index, 1);

    console.log(step_details);
    setStepDetails(step_details);
    // const deleteHighSchool=await axios.delete(`${url}application/delete-high-school/${id}`);
  }

  const handlePostHighSchoolDelete = async (id) => {};
  const dispatch = useDispatch();
  const errDialog = useSelector((state) => {
    return state.dialogReducer;
  });

  const courses = useSelector((state) => {
    return state.coursesReducer.courses;
  });

  const semPeriods = useSelector((state) => {
    return state.semPeriodReducer.semPeriods;
  });
  // const book_categories = useSelector((state) => {
  //   return state.categoriesReducer;
  // });

  return (
    <>
      <ErrorModal />
      <LoaderModal
        loaderMessage={loaderMessage}
        openLoader={openLoader}
        setOpenLoader={setOpenLoader}
        loading={loading}
        error={error}
        onSuccessButtonLable={onSuccessButtonLable}
        onSuccessCallback={onSuccessCallback}
        onErrorButtonLable={onErrorButtonLable}
        onErrorCallback={onErrorCallback}
      />

      <div className="addBookWrapper" style={{ height: "100%" }}>
        <Formik
          // enableReinitialize={true}
          initialValues={initialValuesHighSchool}
          onSubmit={onSubmitDetailsHighSchool}
          validationSchema={validationSchemaHighSchool}
        >
          {({
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            isValid,
            isSubmitting,
            setFieldValue,
            setValues,
          }) => (
            <Form>
              <div className="addBookContainer">
                <div className="addBookDetails">
                  <div
                    className="fullWidthWrapper"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="formControl"
                      //   style={{ flex: 1, padding: 10, boxSizing: "border-box" }}
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          gap: 10,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <ErrorOutline
                            style={{ fontSize: 50 }}
                            color="warning"
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            style={{
                              fontWeight: 500,
                              fontSize: 13,
                              color: "#444",
                            }}
                          >
                            High School Qualification is mandatory
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            style={{
                              fontWeight: 500,
                              fontSize: 13,
                              color: "#444",
                            }}
                          >
                            If you do not have a high school certificate(s) or
                            result slip, kindly attach any proof of results
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            style={{
                              fontWeight: 500,
                              fontSize: 13,
                              color: "#444",
                            }}
                          >
                            File Types allowed:
                            <span style={{ color: "grey" }}>
                              (jpeg/jpg/png/pdf)
                            </span>
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="addBookCaption">
                  <Typography variant="subtitle2">
                    <span className="header2">High School Qualifications</span>
                  </Typography>
                </div>

                {stepDetails.educationDetails.highSchool &&
                stepDetails.educationDetails.highSchool.length > 0 &&
                !viewHighSchoolInput ? (
                  <>
                    <div style={{ width: "100%", marginTop: "20px" }}>
                      {stepDetails.educationDetails.highSchool.map(
                        (item, index) => {
                          return (
                            <div
                              key={index}
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 10,
                                borderBottom: "1px solid #f0f0f0",
                                padding: 5,
                              }}
                              className="highlight-row"
                            >
                              <div style={{ minWidth: "8%", color: "#011846" }}>
                                <Typography
                                  variant="subtitle2"
                                  style={{ fontSize: 11 }}
                                >
                                  ({item.highSchoolSystem.toUpperCase()}) &nbsp;
                                  &nbsp;
                                  <span>Graduation:</span>:
                                  {item.graduationDate.toUpperCase()}
                                </Typography>
                              </div>
                              <div
                                style={{ color: "#011846", minWidth: "10%" }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  style={{ fontSize: 11 }}
                                >
                                  <span>Index:</span>:
                                  {item.indexNumber.toUpperCase()}
                                </Typography>
                              </div>
                              <div style={{ color: "#011846", minWidth: "5%" }}>
                                <Typography
                                  variant="subtitle2"
                                  style={{ fontSize: 11 }}
                                >
                                  <span>Grade:</span>:
                                  {item.meanGrade.toUpperCase()}
                                </Typography>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  flexGrow: 1,
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  style={{ fontSize: "11px" }}
                                >
                                  {item.institutionName.toUpperCase()}{" "}
                                </Typography>
                                <div>
                                  <Tooltip
                                    variant=""
                                    title="Delete"
                                    placement="left"
                                  >
                                    {/* <Clear
                                      style={{
                                        cursor: "pointer",
                                        fontSize: 25,
                                      }}
                                      onClick={() => {
                                        hadleHighSchoolDelete(item.id, index);
                                      }}
                                      // onClick={() => {
                                      //   setContributors(
                                      //     contributors.filter((citem, item_index) => {
                                      //       return index !== item_index;
                                      //     })
                                      //   );
                                      // }}
                                    /> */}
                                  </Tooltip>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                        marginTop: 20,
                      }}
                    >
                      <Button
                        variant="outlined"
                        size="small"
                        color="success"
                        type="submit"
                        style={{
                          textTransform: "capitalize",
                          color: "CaptionText",
                        }}
                        startIcon={<Add color="success" />}
                        onClick={() => {
                          setViewHighSchoolInput((val) => {
                            return !val;
                          });
                        }}
                      >
                        Add New High School
                      </Button>
                    </div>
                  </>
                ) : null}
                {viewHighSchoolInput ? (
                  <div className="addBookDetails">
                    <div
                      className="fullWidthWrapper"
                      style={{
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>high School System:</label>
                        <Field
                          as="select"
                          name="highSchoolSystem"
                          id="highSchoolSystem"
                          // style={{ width: "90%" }}
                        >
                          <option
                            style={{ fontSize: 12, fontFamily: "sans-serif" }}
                            value=""
                          >
                            Select High School System
                          </option>
                          <option value="KCSE">KCSE</option>
                          <option value="IGCSE">IGCSE</option>
                          <option value="IB">IB</option>
                          <option value="GCE">GCE</option>
                        </Field>
                        <ErrorMessage
                          name="highSchoolSystem"
                          component={ErrorText}
                        />
                      </div>

                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Cerficate Description</label>
                        <Field
                          as="select"
                          name="certificateDescription"
                          id="certificateDescription"
                          // style={{ width: "90%" }}
                        >
                          <option value="">--select--</option>
                          <option value="certificate">Certificate</option>
                          <option value="result slip">Result Slip</option>
                          <option value="KNQA letter">KNQA letter</option>
                          <option value="CUE Letter">CUE Letter</option>
                        </Field>
                        <ErrorMessage
                          name="certificateDescription"
                          component={ErrorText}
                        />
                      </div>

                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Index/Exam Registration Number</label>
                        <Field
                          type="text"
                          name="indexNumber"
                          id="indexNumber"
                        />

                        <ErrorMessage
                          name="indexNumber"
                          component={ErrorText}
                        />
                      </div>
                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Institution Name:</label>
                        <Field
                          type="text"
                          name="institutionName"
                          id="institutionName"
                          // style={{ width: "90%" }}
                        />
                        <ErrorMessage
                          name="institutionName"
                          component={ErrorText}
                        />
                      </div>
                    </div>
                    <div
                      className="fullWidthWrapper"
                      style={{
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Start Date:</label>
                        <Field
                          type="date"
                          name="startDate"
                          id="startDate"
                          // style={{ width: "90%" }}
                        />
                        <ErrorMessage name="startDate" component={ErrorText} />
                      </div>

                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Completion Date:</label>
                        <Field
                          type="date"
                          name="endDate"
                          id="endDate"
                          // style={{ width: "90%" }}
                        />
                        <ErrorMessage name="endDate" component={ErrorText} />
                      </div>

                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Graduation Date:</label>
                        <Field
                          type="date"
                          name="graduationDate"
                          id="graduationDate"
                          // style={{ width: "90%" }}
                        />
                        <ErrorMessage
                          name="graduationDate"
                          component={ErrorText}
                        />
                      </div>
                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Mean Grade/Award:</label>
                        <Field type="text" name="meanGrade" id="meanGrade" />

                        <ErrorMessage name="meanGrade" component={ErrorText} />
                      </div>
                    </div>
                    <div
                      className="fullWidthWrapper"
                      style={{
                        flexWrap: "wrap",
                      }}
                    >
                      <div className="formControl" style={{ flex: 1 }}>
                        <label>KCSE result slip/certificate</label>
                        <input
                          type="file"
                          name="resultSlipFile"
                          onChange={(e) => {
                            setResultSlipFile(e.target.files[0]);
                            setFieldValue("resultSlip", e.target.files[0]);
                          }}
                          style={{ width: "auto" }}
                        />
                        <ErrorMessage name="resultSlip" component={ErrorText} />
                      </div>
                      <div className="formControl" style={{ flex: 1 }}>
                        <label>High School Leaving Certificate</label>
                        <input
                          type="file"
                          onChange={(e) => {
                            setFieldValue(
                              "leavingCertificate",
                              e.target.files[0]
                            );
                          }}
                        />
                        <ErrorMessage
                          name={"leavingCertificate"}
                          component={ErrorText}
                        />
                      </div>

                      <div className="formControl" style={{ flex: 1 }}></div>
                      <div className="formControl" style={{ flex: 1 }}></div>
                    </div>
                    <div
                      className="fullWidthWrapper"
                      style={{
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          margin: 10,
                          paddingTop: 10,
                        }}
                      >
                        <Button
                          variant="outlined"
                          size="medium"
                          color="success"
                          type="submit"
                          style={{
                            textTransform: "capitalize",
                            color: "CaptionText",
                          }}
                          startIcon={<Save color="success" />}
                        >
                          Save High School
                        </Button>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </Form>
          )}
        </Formik>

        <Formik
          // enableReinitialize={true}
          initialValues={initialValuesPostHighSchool}
          onSubmit={onSubmitDetailsPostHighSchool}
          validationSchema={validationSchemaPostHighSchool}
        >
          {({
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            isValid,
            isSubmitting,
            setFieldValue,
            setValues,
          }) => (
            <Form>
              <div className="addBookContainer">
                <div className="addBookCaption">
                  <Typography variant="subtitle2">
                    <span className="header2">
                      Post High School Qualifications{" "}
                      <span style={{ fontSize: 12 }}> (optional)</span>
                    </span>
                  </Typography>
                </div>
                {}
                {stepDetails.educationDetails.PostHighSchool &&
                stepDetails.educationDetails.PostHighSchool.length > 0 ? (
                  <>
                    <div style={{ width: "100%", marginTop: "20px" }}>
                      {stepDetails.educationDetails.PostHighSchool.map(
                        (item, index) => {
                          return (
                            <div
                              key={index}
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 10,
                                borderBottom: "1px solid #f0f0f0",
                                padding: 5,
                              }}
                              className="highlight-row"
                            >
                              <div style={{ minWidth: "8%", color: "#011846" }}>
                                <Typography
                                  variant="subtitle2"
                                  style={{ fontSize: 11 }}
                                >
                                  ({item.category.toUpperCase()}) &nbsp; &nbsp;
                                  <span>Graduation:</span>:
                                  {item.graduationDate.toUpperCase()}
                                </Typography>
                              </div>

                              <div style={{ color: "#011846", minWidth: "5%" }}>
                                <Typography
                                  variant="subtitle2"
                                  style={{ fontSize: 11 }}
                                >
                                  <span>Grade:</span>:
                                  {item.meanGrade.toUpperCase()}
                                </Typography>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  flexGrow: 1,
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  style={{ fontSize: "11px" }}
                                >
                                  {item.institutionName.toUpperCase()}{" "}
                                </Typography>
                                <div>
                                  <Tooltip
                                    variant=""
                                    title="Delete"
                                    placement="left"
                                  >
                                    <Clear
                                      style={{
                                        cursor: "pointer",
                                        fontSize: 25,
                                      }}
                                      onClick={() => {
                                        handlePostHighSchoolDelete(
                                          item.id,
                                          index
                                        );
                                      }}
                                      // onClick={() => {
                                      //   setContributors(
                                      //     contributors.filter((citem, item_index) => {
                                      //       return index !== item_index;
                                      //     })
                                      //   );
                                      // }}
                                    />
                                  </Tooltip>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                        marginTop: 20,
                      }}
                    >
                      <Button
                        variant="outlined"
                        size="small"
                        color="success"
                        type="submit"
                        style={{
                          textTransform: "capitalize",
                          color: "CaptionText",
                        }}
                        startIcon={<Add color="success" />}
                        onClick={() => {
                          setViewPostHighSchoolInput((val) => {
                            return !val;
                          });
                        }}
                      >
                        Add New Post High School Qualification
                      </Button>
                    </div>
                  </>
                ) : null}
                {viewPostHighSchoolInput ? (
                  <div className="addBookDetails">
                    <div
                      className="fullWidthWrapper"
                      style={{
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Category/Type:</label>
                        <Field
                          as="select"
                          name="category"
                          id="category"
                          // style={{ width: "90%" }}
                        >
                          <option
                            style={{ fontSize: 12, fontFamily: "sans-serif" }}
                            value=""
                          >
                            Select Category
                          </option>
                          <option value="Certificate">Certificate</option>
                          <option value="Diploma">Diploma</option>
                          <option value="Higher Diploma">Higher Diploma</option>
                          <option value="Degree">Degree/Undergraduate</option>
                          <option value="Masters">Masters</option>
                          <option value="Other">Other</option>
                        </Field>
                        <ErrorMessage name="category" component={ErrorText} />
                      </div>

                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Qualification Description</label>
                        <Field
                          as="select"
                          name="qualificationDescription"
                          id="qualificationDescription"
                          // style={{ width: "90%" }}
                        >
                          <option value="">--select--</option>
                          <option value="certificate">Certificate</option>
                          <option value="result slip">Result Slip</option>
                          <option value="KNQA letter">KNQA letter</option>
                          <option value="CUE Letter">CUE Letter</option>
                        </Field>
                        <ErrorMessage
                          name="qualificationDescription"
                          component={ErrorText}
                        />
                      </div>

                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Institution Name:</label>
                        <Field
                          type="text"
                          name="institutionName"
                          id="institutionName"
                          // style={{ width: "90%" }}
                        />
                        <ErrorMessage
                          name="institutionName"
                          component={ErrorText}
                        />
                      </div>

                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Start Date:</label>
                        <Field
                          type="date"
                          name="startDate"
                          id="startDate"
                          // style={{ width: "90%" }}
                        />
                        <ErrorMessage name="startDate" component={ErrorText} />
                      </div>
                    </div>
                    <div
                      className="fullWidthWrapper"
                      style={{
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Completion Date:</label>
                        <Field
                          type="date"
                          name="endDate"
                          id="endDate"
                          // style={{ width: "90%" }}
                        />
                        <ErrorMessage name="endDate" component={ErrorText} />
                      </div>

                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Graduation Date:</label>
                        <Field
                          type="date"
                          name="graduationDate"
                          id="graduationDate"
                          // style={{ width: "90%" }}
                        />
                        <ErrorMessage
                          name="graduationDate"
                          component={ErrorText}
                        />
                      </div>
                      <div
                        className="formControl"
                        style={{
                          flex: 1,
                        }}
                      >
                        <label>Mean Grade/Award:</label>
                        <Field type="text" name="meanGrade" id="meanGrade" />

                        <ErrorMessage name="meanGrade" component={ErrorText} />
                      </div>

                      <div className="formControl" style={{ flex: 1 }}>
                        <label>
                          Certificate{" "}
                          <span style={{ color: "grey" }}>
                            (jpeg/jpg/png/pdf)
                          </span>
                        </label>
                        <input
                          type="file"
                          onChange={(e) => {
                            //   setPassportPhoto(e.target.files[0]);
                            setFieldValue("certificate", e.target.files[0]);
                          }}
                          style={{ width: "auto" }}
                        />
                        <ErrorMessage
                          name="certificate"
                          component={ErrorText}
                        />
                      </div>
                    </div>
                    <div
                      className="fullWidthWrapper"
                      style={{
                        flexWrap: "wrap",
                      }}
                    >
                      <div className="formControl" style={{ flex: 1 }}>
                        <label>Transcript</label>
                        <input
                          type="file"
                          onChange={(e) => {
                            setFieldValue("transcript", e.target.files[0]);
                          }}
                        />
                        <ErrorMessage
                          name={"transcript"}
                          component={ErrorText}
                        />
                      </div>

                      <div className="formControl" style={{ flex: 1 }}></div>
                      <div className="formControl" style={{ flex: 1 }}></div>
                      <div className="formControl" style={{ flex: 1 }}></div>
                    </div>
                    <div
                      className="fullWidthWrapper"
                      style={{
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          margin: 10,
                          paddingTop: 10,
                        }}
                      >
                        <Button
                          variant="outlined"
                          size="medium"
                          color="success"
                          type="submit"
                          style={{
                            textTransform: "capitalize",
                            color: "CaptionText",
                          }}
                          startIcon={<Save color="success" />}
                        >
                          Save Post High School
                        </Button>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </Form>
          )}
        </Formik>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: 10,
            marginLeft: 0,
            paddingTop: 10,
            marginRight: 0,
          }}
        >
          <button
            type="submit"
            className="btn-secondary"
            onClick={() => {
              setStep((val) => {
                return val - 1;
              });
            }}
          >
            &lt; Back to Program Details
          </button>
          <button
            type="submit"
            className="btn-primary"
            onClick={() => {
              if (stepDetails.educationDetails.highSchool != null) {
                setStep((val) => {
                  return val + 1;
                });
              } else {
                dispatch(
                  errorDialogOpen("Error Highschool Details are required")
                );
              }
            }}
            // disabled={!isValid || isSubmitting}
          >
            Save and Continue
          </button>
        </div>
      </div>
      <ErrorModal />
    </>
  );
}
